export interface IKey {
  name: string;
  key: string;
}

export const Token: IKey = {
  name: 'A7ng6Gf4ZC',
  key: 'pQ&SG9paN#E9v$mE*XRheFhVCVdY5t',
};
export const Expire: IKey = {
  name: '5QByNTCAsg',
  key: 'JhG7DDgA#G?vABJ#2k?$mYSRukmdAQ',
};
export const Language: IKey = {
  name: 'fCqBAQRp7A',
  key: 'h#znCZbUB$2vXfeAf*FSKPAdNG#Y8V',
};
export const ActiveRole: IKey = {
  name: 'sC5nmnMa9c',
  key: 'uSSnCP5TU$99fKB$2vXfeAf*FSKasd',
};

export const ForgetPasswordRetryTimer: IKey = {
  name: 's33nmNga0u',
  key: 'SSnCP5TU$99fKE9vCZbUDdjsB$2vXf',
};
